import { UAParser } from 'ua-parser-js'

export interface OSInfo {
  type: string | undefined
  name: string | undefined
  version: string | undefined
  osMajorVersion: number | undefined
}

export const parseOSVersion = (userAgent: string): OSInfo => {
  const parser = new UAParser(userAgent)
  const os = parser.getOS()
  const majorVersion = os.version?.split('.')[0] ? parseInt(os.version.split('.')[0]) : undefined

  return {
    type: parser.getDevice().type,
    name: os.name,
    version: os.version,
    osMajorVersion: majorVersion,
  }
}
